export default __webpack_public_path__ + "static/media/users.b07a5945.csv";